import { gql, TypedDocumentNode } from '@apollo/client'

import { ERROR_FRAGMENT } from 'providers/graphql'
import { Data, Variables } from './types'

export const START_AB_TEST: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation startAbTest($input: StartAbTestInput!) {
    startAbTest(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
